import { FunctionComponent, ReactNode, useMemo } from "react";

import { ProgressBars } from "./ProgressBars/ProgressBars";
import { ICustomProgressColumn, IProgressColumn, IProgressVisualizationProps } from "./progressHandler.types";
import { useProgressHandler } from "./useProgressHandler";

import "./ProgressHandler.scss";

export type { ICustomProgressColumn, IProgressColumn, IProgressVisualizationProps } from "./progressHandler.types";

interface IProgressHandlerProps {
  progresscolumns: (IProgressColumn | ICustomProgressColumn)[];
  progressVisualizationTemplate?: (props: IProgressVisualizationProps) => ReactNode;
  cancelProgress: () => void;
  connectionSetupCompleted: () => void;
}

export const ProgressHandler: FunctionComponent<IProgressHandlerProps> = (props: IProgressHandlerProps) => {
  const { progressTitles, progressValues, cancelProgress } = useProgressHandler({
    progresscolumns: props.progresscolumns,
    cancelProgress: props.cancelProgress,
    connectionSetupCompleted: props.connectionSetupCompleted,
  });

  const progressVisualizationMemo = useMemo(() => {
    if (props.progressVisualizationTemplate) {
      return props.progressVisualizationTemplate({
        progressTitles,
        progressValues,
        cancelProgress: cancelProgress,
      });
    }

    return (
      <ProgressBars progressTitles={progressTitles} progressValues={progressValues} cancelProgress={cancelProgress} />
    );
  }, [progressTitles, progressValues, props.progressVisualizationTemplate]);

  return progressVisualizationMemo;
};
